var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedflag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.68712,
    y: 0.667344,
    width: 46.2585,
    height: 26.6667,
    fill: "white",
    stroke: "#5B6871",
    strokeWidth: 0.544218
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6733 0.939453H13.1495L19.7346 4.20476L13.1495 5.83741L19.7346 8.5585L13.1495 11.2796L19.1359 14.0007L13.1495 16.1775L19.7346 18.8986L13.7482 21.6197L19.7346 24.3408L13.1495 27.0619H46.6733V0.939453Z",
    fill: "#FE0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedflag);
export default __webpack_public_path__ + "static/media/redflag.572ec45183c767ad1fd7090116d19217.svg";
export { ForwardRef as ReactComponent };